const REQUEST_STATUSES = {
    NOT_STARTED: 'REQUEST_STATUS_NOT_STARTED',
    PENDING: 'REQUEST_STATUS_PENDING',
    SUCCESS: 'REQUEST_STATUS_SUCCESS',
    ERROR: 'REQUEST_STATUS_ERROR',
};
export default REQUEST_STATUSES;
